export enum Privacy {
  PRIVATE = "private",
  UNLISTED = "unlisted",
  PUBLIC = "public",
}
